// @flow
import Component from './component'
export default () => ({
  path: 'tickets/:id',
  element: <Component />,
  key: 'tickets',
})
